(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4289],{

/***/ 78456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _opt_build_repo_node_modules_pnpm_next_12_1_4_yscj52izot5zgtrz33zielpism_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6666);
/* harmony import */ var _opt_build_repo_node_modules_pnpm_next_12_1_4_yscj52izot5zgtrz33zielpism_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_pnpm_next_12_1_4_yscj52izot5zgtrz33zielpism_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85170);
/* harmony import */ var _components_global_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80772);
/* harmony import */ var _CodeBlock_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54125);
/* harmony import */ var _CodeBlock_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_CodeBlock_module_scss__WEBPACK_IMPORTED_MODULE_4__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var didInit = false;
var CodeBlock = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _code = param.code, code1 = _code === void 0 ? "" : _code, _language = param.language, language = _language === void 0 ? "" : _language, _copyEnabled = param.copyEnabled, copyEnabled = _copyEnabled === void 0 ? true : _copyEnabled, copyButtonLabel = param.copyButtonLabel;
    var clipboardButtonStateToTextMap = {
        default: copyButtonLabel || "Copy To Clipboard",
        success: "Copied!",
        error: "Error!"
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), clipboardSupported = ref[0], setClipboardSupported = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("default"), clipboardButtonState = ref1[0], setClipboardButtonState = ref1[1];
    var preEl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var copyContentToClipboard = function() {
        var _ref = _asyncToGenerator(_opt_build_repo_node_modules_pnpm_next_12_1_4_yscj52izot5zgtrz33zielpism_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var preCurrent, codeEl, code;
            return _opt_build_repo_node_modules_pnpm_next_12_1_4_yscj52izot5zgtrz33zielpism_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setClipboardButtonState("default");
                        _ctx.prev = 1;
                        preCurrent = preEl === null || preEl === void 0 ? void 0 : preEl.current;
                        codeEl = preCurrent.querySelector("code");
                        code = codeEl.innerText;
                        _ctx.next = 7;
                        return navigator.clipboard.writeText(code);
                    case 7:
                        setClipboardButtonState("success");
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](1);
                        setClipboardButtonState("error");
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    10
                ]
            ]);
        }));
        return function copyContentToClipboard() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (clipboardButtonState === "default") return;
        var timer = setTimeout(function() {
            return setClipboardButtonState("default");
        }, 2000);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        clipboardButtonState
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!didInit) {
            didInit = true;
            // Check if clipboard API is supported before rendering copy button
            setClipboardSupported(window.navigator !== undefined && window.navigator.clipboard !== undefined);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: [
            (_CodeBlock_module_scss__WEBPACK_IMPORTED_MODULE_4___default().CodeBlock),
            className
        ].join(" "),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (_CodeBlock_module_scss__WEBPACK_IMPORTED_MODULE_4___default().CodeBlock__inner),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (_CodeBlock_module_scss__WEBPACK_IMPORTED_MODULE_4___default().CodeBlock__label),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        children: language
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (_CodeBlock_module_scss__WEBPACK_IMPORTED_MODULE_4___default().CodeBlock__code),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("pre", {
                        ref: preEl,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("code", {
                            children: code1
                        })
                    })
                }),
                clipboardSupported && copyEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_global_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: (_CodeBlock_module_scss__WEBPACK_IMPORTED_MODULE_4___default().CodeBlock__button),
                    type: "button",
                    variant: "secondary",
                    callBack: copyContentToClipboard,
                    children: clipboardButtonStateToTextMap[clipboardButtonState]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CodeBlock);


/***/ }),

/***/ 74289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var _components_global_CodeBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78456);


var CodeBlockWrapper = function(param) {
    var blok = param.blok;
    var code = blok.code, language = blok.language, copy_enabled = blok.copy_enabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_CodeBlock__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            code: code,
            language: language,
            copyEnabled: copy_enabled
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CodeBlockWrapper);


/***/ }),

/***/ 54125:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CodeBlock":"CodeBlock_CodeBlock__5ctHs","CodeBlock__label":"CodeBlock_CodeBlock__label__y57r1","CodeBlock__button":"CodeBlock_CodeBlock__button__TESET"};

/***/ })

}]);